const changeProfilePictureStr = {
  toastr: 'Altered profile picture',
  toastr1: 'Successfully altered profile picture'
};

export default changeProfilePictureStr;
